// Theme helpers (BBD-77). The roster is locked at three themes.
// Keep this file free of React so the same normalization can be used by
// public/index.html's bootstrap (which duplicates the legacy map inline).

export const THEMES = ["default", "dark", "purple"];

export const THEME_LABELS = {
    default: "Default (No Theme)",
    dark: "Dark Theme",
    purple: "Purple Theme",
};

export const THEME_STORAGE_KEY = "theme";

const LEGACY_VALUES = {
    "default": "default",
    "default (no theme)": "default",
    "dark theme": "dark",
    "dark": "dark",
    "purple theme": "purple",
    "purple": "purple",
    // Dropped themes (never implemented) fall back to Default.
    "gray theme": "default",
    "dark gray theme": "default",
    "dark purple theme": "default",
};

/** Map any stored/legacy value ("Dark Theme", "dark", junk) to a canonical id. */
export function normalizeTheme(value) {
    if (value === null || value === undefined) return "default";
    const key = String(value).trim().toLowerCase();
    return LEGACY_VALUES[key] || "default";
}

/** The label the team-workspace backend field still stores ("Dark Theme"). */
export function toWorkspaceThemeValue(theme) {
    switch (normalizeTheme(theme)) {
        case "dark": return "Dark Theme";
        case "purple": return "Purple Theme";
        default: return "Default";
    }
}

export function readStoredTheme() {
    try {
        return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
    } catch (e) {
        return "default";
    }
}

export function writeStoredTheme(theme) {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, normalizeTheme(theme));
    } catch (e) {
        /* storage unavailable (private mode) — the in-memory value still applies */
    }
}

export function applyThemeAttribute(theme) {
    document.documentElement.setAttribute("data-theme", normalizeTheme(theme));
}
